// дескриптор для реквизитов компании
export const Requisites = {
    id: 'requisites',
    api: 'defBridge',
    title: 'Реквизиты',
    showCheckboxes: false,
    pdf: true,
    items: [{
        id: 'nameCompany', items: [
            { id: 'fullName', title: 'Полное наименование' },
            { id: 'abbrName', title: 'Сокращённое наименование' },
        ]
    },
    {
        id: 'addresCompany', items: [
            { id: 'inn_kpp', title: 'ИНН/КПП' },
            { id: 'ogrn', title: 'ОГРН' },
            { id: 'jurid_addres', title: 'Юридический адрес' },
            { id: 'fact_addres', title: 'Фактический адрес' },
        ]
    },
        
        {
        id: 'bank_requisites', title: 'Банковские реквизиты', items: [
            { id: 'bik', title: 'БИК' },
            { id: 'korespond_score', title: 'Корреспондентский счет' },
            { id: 'kpp', title: 'КПП' },
        ]
    },
    ],
};